var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { format } from 'date-fns';
import Icon from '../../Icon';
import Typography from '../../Typography';
import { TucarTheme } from '../../theme';
import { getMonthName, isValidDate } from '../utils';
import { DropDownGoBackButtonWrapper, DropdownItemStyled, DropdownItemWrapperStyled, DropdownItemContainerStyled, } from './styled';
const itemHeight = 35;
const itemMargin = 11.5;
const CalendarDropdown = (_a) => {
    var props = __rest(_a, []);
    const { selectedView, filteredViews, selectedYear, selectedDate, selectedMonth, inputFormat, setters, isOpen, handleDisableMonth, handleDisableYear, maxYear, minYear, } = props;
    const { setIsOpen, setSelectedView, handleSelectedValuesChange, setDebouncedValue } = setters;
    const availableYears = useMemo(() => [...Array(maxYear + 1 - minYear).keys()].map((year) => year + minYear), [maxYear, minYear]);
    const scrollToSelected = (dropdown, selectedIndex) => {
        if (dropdown && selectedIndex !== null) {
            // eslint-disable-next-line no-param-reassign
            dropdown.scrollTop = selectedIndex * itemHeight + itemMargin;
        }
    };
    const handleDateChange = (dateValue, itemValue, changeItemType) => {
        handleSelectedValuesChange({ date: dateValue, [changeItemType]: itemValue });
        setDebouncedValue(format(dateValue, inputFormat));
    };
    const handleDropdownItemClick = (value, type) => {
        if (type === 'year' && handleDisableYear(value))
            return;
        if (type === 'month' && handleDisableMonth(value, selectedYear))
            return;
        const baseDate = isValidDate(selectedDate) ? selectedDate : new Date();
        baseDate.setMonth(type === 'year' ? selectedMonth : value);
        baseDate.setFullYear(type === 'year' ? value : selectedYear);
        if (type === 'year') {
            handleDateChange(baseDate, value, type);
            if (filteredViews.includes('month'))
                setSelectedView('month');
            else
                setIsOpen(false);
        }
        else {
            handleDateChange(baseDate, value, type);
            if (filteredViews.includes('year'))
                setSelectedView('year');
            setIsOpen(false);
        }
    };
    useEffect(() => {
        if (availableYears.length <= 1 && selectedView === 'year')
            setSelectedView('month');
    }, [availableYears, selectedView, isOpen]);
    const renderYears = () => (_jsx(DropdownItemContainerStyled, Object.assign({ ref: (dropdown) => scrollToSelected(dropdown, selectedYear ? selectedYear - minYear : null) }, { children: availableYears.map((currentYear) => {
            const yearLabel = currentYear.toString();
            const isYearDisabled = handleDisableYear(currentYear);
            return (_jsx(DropdownItemStyled, Object.assign({ disabled: isYearDisabled, name: yearLabel, onClick: () => handleDropdownItemClick(currentYear, 'year'), selected: selectedYear === currentYear, value: yearLabel }, { children: _jsx(Typography, Object.assign({ "data-disabled": isYearDisabled, style: Object.assign({ lineHeight: '17px' }, (isYearDisabled
                        ? { color: TucarTheme.colors.gray600, cursor: 'not-allowed' }
                        : {})) }, { children: currentYear })) }), currentYear));
        }) }), "year-dropdown"));
    const renderMonths = () => (_jsxs(DropdownItemContainerStyled, Object.assign({ ref: (dropdown) => scrollToSelected(dropdown, selectedMonth) }, { children: [filteredViews.includes('year') && availableYears.length > 1 && (_jsxs(DropDownGoBackButtonWrapper, Object.assign({ onClick: () => setSelectedView('year') }, { children: [_jsx(Icon, { color: "conic-gradient(from 51deg, #FFF, #0057B8)", name: "arrowBackIosFilled", size: "16px" }), _jsx(Typography, Object.assign({ style: {
                            color: TucarTheme.colors.blue500,
                            lineHeight: '17px',
                        } }, { children: "Atr\u00E1s" }))] }))), [...Array(12).keys()].map((currentMonth) => {
                const monthLabel = currentMonth.toString();
                const isMonthDisabled = handleDisableMonth(currentMonth, selectedYear);
                return (_jsx(DropdownItemStyled, Object.assign({ disabled: isMonthDisabled, name: monthLabel, onClick: () => handleDropdownItemClick(currentMonth, 'month'), selected: selectedMonth === currentMonth, value: monthLabel }, { children: _jsx(Typography, Object.assign({ "data-disabled": isMonthDisabled, style: Object.assign({ marginLeft: '25px', lineHeight: '17px' }, (isMonthDisabled
                            ? { color: TucarTheme.colors.gray600, cursor: 'not-allowed' }
                            : {})) }, { children: getMonthName(currentMonth) })) }), currentMonth));
            })] }), "month-dropdown"));
    const renderDropDownContent = () => {
        if (selectedView === 'year' && filteredViews.includes('year')) {
            return renderYears();
        }
        if (selectedView === 'month' && filteredViews.includes('month')) {
            return renderMonths();
        }
        return _jsx("div", {});
    };
    return (_jsx(DropdownItemWrapperStyled, Object.assign({ open: isOpen }, { children: isOpen ? renderDropDownContent() : _jsx("div", {}) })));
};
export default CalendarDropdown;
//# sourceMappingURL=index.js.map